import CategoryLink from './components/CategoryLink';
import ContentSection from './components/ContentSection';
import PageHeader from './components/PageHeader';
import EditableTemplateHeader from './components/EditableTemplateHeader';
import StickyUseTemplateDesktop from './components/StickyUseTemplateDesktop';
import StickyUseTemplateMobile from './components/StickyUseTemplateMobile';
import FaqItems from './components/FaqItems';
export default {
  CategoryLink: CategoryLink,
  ContentSection: ContentSection,
  PageHeader: PageHeader,
  EditableTemplateHeader: EditableTemplateHeader,
  StickyUseTemplateDesktop: StickyUseTemplateDesktop,
  StickyUseTemplateMobile: StickyUseTemplateMobile,
  FaqItems: FaqItems
};